export const securityAdminsSitesKeys = {
  all: ["security-admins-sites"] as const,
  lists: () => [...securityAdminsSitesKeys.all, "list"] as const,
  list: () => [...securityAdminsSitesKeys.lists()] as const,
};
